import { IOpportunity, ISearchOpp } from 'global/interfaces/opportunity';
import { Dispatch, SetStateAction, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { nameof } from 'ts-simple-nameof';
import { getOpportunities } from 'services/opportunityService';
import { showError } from 'utils/errorHandler';
import { PagedResult } from 'global/interfaces/PagedResult';
import { RoundButton } from 'components/common/Button/RoundButton';

interface IOppPagerProps {
  loadMore: boolean;
  setPagedResult: Dispatch<SetStateAction<PagedResult<IOpportunity[]>>>;
}

export default function OppPager({ loadMore, setPagedResult }: IOppPagerProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);

  const pageNumber = parseInt(searchParams.get(nameof<ISearchOpp>(x => x.pageNumber)) ?? '1');

  const handleNextPage = () => {
    if (!loadMore) return;
    setLoading(true);
    searchParams.set(
      nameof<ISearchOpp>(x => x.pageNumber),
      (pageNumber + 1).toString(),
    );
    setSearchParams(searchParams, { replace: true });

    getOpportunities(searchParams)
      .then(res =>
        setPagedResult(prev => ({
          data: [...prev.data, ...res.data],
          total: res.total,
        })),
      )
      .catch(showError)
      .finally(() => setLoading(false));
  };

  return (
    <>
      {loadMore && (
        <RoundButton
          onClick={handleNextPage}
          loading={loading}
          loadingPosition="end"
          color="primary"
          sx={{ color: theme => theme.palette.primary.main }}
          variant="outlined"
        >
          Load more
        </RoundButton>
      )}
    </>
  );
}
